import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  users: [],
  fetchUsersLoading: false,
  fetchUsersError: null,

  user: {},
  fetchUserLoading: false,
  fetchUserError: null,

  addUserIsLoading: false,

  updateUserIsLoading: false,

  verifyUserLoading: false,

  idRecinto: null
};

export const usersSlice = createSlice({
  name: 'USERS',
  initialState,
  reducers: {
    fetchUsersStart: state => {
      state.fetchUsersLoading = true;
      state.fetchUsersError = null;
    },
    fetchUsersSuccess: (state, action) => {
      state.fetchUsersLoading = false;
      state.users = action.payload.users;
    },
    fetchUsersError: (state, action) => {
      state.fetchUsersLoading = false;
      state.fetchUsersError = action.payload;
    },

    fetchUserStart: state => {
      state.fetchUserLoading = true;
      state.fetchUserError = null;
    },
    fetchUserSuccess: (state, action) => {
      state.fetchUserLoading = false;
      state.user = action.payload;
    },
    fetchUserError: (state, action) => {
      state.fetchUserLoading = false;
      state.fetchUserError = action.payload;
    },

    addUserStart: state => {
      state.addUserIsLoading = true;
    },
    addUserSuccess: (state, action) => {
      state.addUserIsLoading = false;
      state.users = [action.payload, ...state.users];
    },
    addUserError: state => {
      state.addUserIsLoading = false;
    },

    updateUserStart: state => {
      state.updateUserIsLoading = true;
    },
    updateUserSuccess: (state, action) => {
      state.updateUserIsLoading = false;
      state.users = state.users.map(user => {
        if (user.id === action.payload.id) {
          return action.payload;
        }
        return user;
      });
    },
    updateUserError: state => {
      state.updateUserIsLoading = false;
    },

    verifyUserStart: state => {
      state.verifyUserLoading = true;
    },
    verifyUserSuccess: state => {
      state.verifyUserLoading = false;
    },
    verifyUserError: state => {
      state.verifyUserLoading = false;
    },

    saveIdRecinto: (state, action) => {
      state.idRecinto = action.payload;
    }
  }
});

export const {
  fetchUsersStart,
  fetchUsersSuccess,
  fetchUsersError,
  fetchUserStart,
  fetchUserSuccess,
  fetchUserError,
  saveIdRecinto,
  addUserStart,
  addUserSuccess,
  addUserError,
  updateUserStart,
  updateUserSuccess,
  updateUserError,
  verifyUserStart,
  verifyUserSuccess,
  verifyUserError
} = usersSlice.actions;

export default usersSlice.reducer;
